module.exports = __webpack_public_path__ + "logo-trunking.svg?4ed106fed7bb01ff5513d649edff8614";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo-trunking.svg
// module id = 105
// module chunks = 0